import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        // console.info( 'about' );
    }
    init() {
        this.interval = setInterval( () => {

        },300)

    }
    destroy(){
        console.info('destroying about');
        clearInterval( this.interval );
    }
}
